"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHttpError = exports.HttpError = exports.axiosErrorFields = void 0;
const headers_1 = require("./headers");
exports.axiosErrorFields = [
    'code',
    'config',
    'request',
    'response',
    'toJSON',
    '__CANCEL__',
];
class HttpError extends Error {
    constructor(error) {
        super(error.message);
        this.isWixHttpError = true;
        Object.setPrototypeOf(this, HttpError.prototype);
        exports.axiosErrorFields.forEach((key) => {
            // index is type checked, but converting into 'any' as suggested in Typescript issues.
            this[key] = error[key];
        });
    }
    get requestId() {
        return (0, headers_1.requestIdOrEmptyString)(this.response);
    }
}
exports.HttpError = HttpError;
function createHttpError(...args) {
    return new HttpError(...args);
}
exports.createHttpError = createHttpError;
//# sourceMappingURL=error.js.map